import SaveIcon from '@mui/icons-material/Save';
import React, { useMemo } from 'react';

import FlatButton from 'components/FlatButton';
import { useTheme } from '@mui/material/styles';

const SaveButton = ({ disabled = false, ...props }) => {
  const theme = useTheme();
  return (
    <FlatButton
      {...props}
      disabled={disabled}
      icon={useMemo(
        () => <SaveIcon htmlColor={disabled ? theme.palette.grey[600] : theme.palette.primary.contrastText} />,
        [disabled],
      )}
      lableColor={disabled ? theme.palette.grey[600] : theme.palette.primary.contrastText}
      label='Save'
    />
  );
};

SaveButton.propTypes = FlatButton.propTypes;

export default SaveButton;
